import { render } from "./PageTitle.vue?vue&type=template&id=4bfa215e&scoped=true"
import script from "./PageTitle.vue?vue&type=script&lang=js"
export * from "./PageTitle.vue?vue&type=script&lang=js"

import "./PageTitle.vue?vue&type=style&index=0&id=4bfa215e&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/线上短信平台/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bfa215e"]])

export default __exports__